/* Core exports */
import { connect } from 'react-redux';

import PublicRoutes from './PublicRoutes';

const mapStateToProps = ({ auth }) => {
  return {
    isUserLoggedIn: !!auth.token,
  };
};

export default connect(mapStateToProps, null)(PublicRoutes);
